import styled from "styled-components";
import {
  Modal,
  Divider,
  Button as ButtonAntd,
  Form as FormAnt,
  DatePicker as DatePickerAnt,
  Alert as AlertAnt,
} from "antd";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-header {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: #fff;
    border-bottom: 1px solid var(--gray-20);
  }

  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #363636;
  }
  .ant-modal-body {
    padding: 0 1rem;

    input {
      border: 1px solid var(--gray-100);
      border-radius: 0.3rem;
      height: 2.7rem;
    }
    .ant-select-selector {
      height: 2.7rem;
      border: 1px solid var(--gray-100);
      border-radius: 0.3rem;
      margin-top: 0.2rem;
      padding: 4px 11px;
    }

    .ant-form-item-label
      > label.ant-form-item-required:not(
        .ant-form-item-required-mark-optional
      )::after {
      display: inline-block;
      color: var(--orange-150);
      content: "*";
    }
    .ant-form-item-label
      > label.ant-form-item-required:not(
        .ant-form-item-required-mark-optional
      )::before {
      content: "";
    }
  }
`;

export const Form = styled(FormAnt)`
  padding: 0 1rem;
  background: var(--white);
  overflow: auto;
  .ant-form-item {
    margin-bottom: 0px;
  }
  .imgPerfir {
    width: 150px;
    height: 150px;
    border-radius: 100px;
  }
  @media only screen and (max-height: 630px) {
    height: 25rem;
  }
  @media only screen and (max-height: 540px) {
    height: 20rem;
  }
`;

export const FormItem = styled(FormAnt.Item)`
  padding: 0.3rem;
`;
export const Container = styled.div`
  overflow-y: auto;
  height: 40rem;
`;

export const DatePicker = styled(DatePickerAnt)`
  width: 100%;
  padding: 0;

  input {
    padding-left: 0.5rem;
  }
`;

export const HeaderDivider = styled(Divider)``;

export const BtnsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const ButtonCancel = styled.button`
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: #000;
  cursor: pointer;
  font-size: 14px;
  height: 36px;
  padding: 0 15px;
  transition: all 0.3s;

  &:hover {
    border-color: #40a9ff;
    color: #40a9ff;
  }
`;

export const ButtonSave = styled(ButtonAntd)`
  background-color: var(--orange-150);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  height: 36px;
  padding: 0 15px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: var(--orange-250);
  }

  &:disabled {
    background-color: #d9d9d9;
    cursor: not-allowed;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 19rem;
`;

export const ProfileImageContainer = styled.div`
  position: relative;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  border: 2px solid var(--gray-20);
`;

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProfileImageUploadOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2rem;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;

  ${ProfileImageContainer}:hover & {
    opacity: 1;
  }

  .dropzone {
    border: none;
    height: 100%;
    color: white;
  }

  p {
    color: white !important;
    font-size: 12px;
    margin: 0;
  }
`;

export const Alert = styled(AlertAnt)`
  margin-top: 0.5rem;
`;
